import axios from 'axios';
import { BASE_URL } from '../components/Constant';

function createSchedule(scheduleData) {
  const endpoint = BASE_URL + 'timesheetSchedule/createSchedule';
  return axios.post(endpoint, scheduleData, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

function getSchedules(params = {}) {
  const endpoint = BASE_URL + 'timesheetSchedule/getSchedules';
  return axios.get(endpoint, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    },
    params
  });
}

function updateSchedule(scheduleId, scheduleData) {
  const endpoint = BASE_URL + `timesheetSchedule/updateSchedule/${scheduleId}`;
  return axios.put(endpoint, scheduleData, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

function bulkPublish(scheduleIds) {
  const endpoint = BASE_URL + 'timesheetSchedule/bulkPublish';
  return axios.put(
    endpoint,
    { scheduleIds },
    {
      headers: {
        // eslint-disable-next-line no-undef
        authorization: `${localStorage.getItem('token')}`
      }
    }
  );
}

function deleteSchedule(scheduleId) {
  const endpoint = BASE_URL + `timesheetSchedule/deleteSchedule/${scheduleId}`;
  return axios.delete(endpoint, {
    headers: {
      // eslint-disable-next-line no-undef
      authorization: `${localStorage.getItem('token')}`
    }
  });
}

const timesheetScheduleService = {
  createSchedule,
  getSchedules,
  updateSchedule,
  bulkPublish,
  deleteSchedule
};

export default timesheetScheduleService;
